/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FxIdWebFeaturesClientCommandsClaimClaimedCommand } from './FxIdWebFeaturesClientCommandsClaimClaimedCommand';
import {
    FxIdWebFeaturesClientCommandsClaimClaimedCommandFromJSON,
    FxIdWebFeaturesClientCommandsClaimClaimedCommandFromJSONTyped,
    FxIdWebFeaturesClientCommandsClaimClaimedCommandToJSON,
    FxIdWebFeaturesClientCommandsClaimClaimedCommandToJSONTyped,
} from './FxIdWebFeaturesClientCommandsClaimClaimedCommand';

/**
 * Ответ со списком команд, выданных клиенту
 * @export
 * @interface FxIdWebFeaturesClientCommandsClaimResponse
 */
export interface FxIdWebFeaturesClientCommandsClaimResponse {
    /**
     * Список команд с lease-токенами
     * @type {Array<FxIdWebFeaturesClientCommandsClaimClaimedCommand>}
     * @memberof FxIdWebFeaturesClientCommandsClaimResponse
     */
    Commands: Array<FxIdWebFeaturesClientCommandsClaimClaimedCommand>;
}

/**
 * Check if a given object implements the FxIdWebFeaturesClientCommandsClaimResponse interface.
 */
export function instanceOfFxIdWebFeaturesClientCommandsClaimResponse(value: object): value is FxIdWebFeaturesClientCommandsClaimResponse {
    if (!('Commands' in value) || value['Commands'] === undefined) return false;
    return true;
}

export function FxIdWebFeaturesClientCommandsClaimResponseFromJSON(json: any): FxIdWebFeaturesClientCommandsClaimResponse {
    return FxIdWebFeaturesClientCommandsClaimResponseFromJSONTyped(json, false);
}

export function FxIdWebFeaturesClientCommandsClaimResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdWebFeaturesClientCommandsClaimResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'Commands': ((json['Commands'] as Array<any>).map(FxIdWebFeaturesClientCommandsClaimClaimedCommandFromJSON)),
    };
}

export function FxIdWebFeaturesClientCommandsClaimResponseToJSON(json: any): FxIdWebFeaturesClientCommandsClaimResponse {
    return FxIdWebFeaturesClientCommandsClaimResponseToJSONTyped(json, false);
}

export function FxIdWebFeaturesClientCommandsClaimResponseToJSONTyped(value?: FxIdWebFeaturesClientCommandsClaimResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Commands': ((value['Commands'] as Array<any>).map(FxIdWebFeaturesClientCommandsClaimClaimedCommandToJSON)),
    };
}

